import { Component } from 'react';
import ActionQueue from './ActionQueue';
import { BasicModal, PopUp } from '@beisen/chaos-ui';
import EditForm from '../../components/Form/EditForm';
import EditOwnerForm from '../../components/Form/EditOwnerForm';
import BatchPage from '../../components/Pages/BatchPage';
import StandardBatchEdit from '../../components/BatchEdit/BatchEditWrapper';
import getTipInfo from './getTipInfo';
import * as html from '../util/html';
import PopIndexView from '../PopIndexView/PopIndexView';
import transLoader from '@beisen/i18n-translation-loader';
const defaultTranslation = {
    cancel: '取消',
    confirm: '确定'
};
export default class CommonPlugin extends Component {
    constructor(props, context) {
        super(props, context);
        this.actions = props.actions;
        this.submitConfirm = this.closeConfirm.bind(this);
        this.clearTipHandler = this.clearTipHandler.bind(this);
        this.selectFields = this.selectFields.bind(this);
        this.onTouchTapOverlay = this.onTouchTapOverlay.bind(this);
        this.cancleModal = this.cancleModal.bind(this);
        this.getAnalysisData = this.getAnalysisData.bind(this);
        this.getFirstField = this.getFirstField.bind(this);
        this.translation = Object.assign(
            {},
            defaultTranslation,
            transLoader({
                cancel: 'common.cancel',
                confirm: 'common.confirm'
            }),
            props.translation
        );
    }

    onTouchTapOverlay() {
        this.props.actions.btnClearFn();
    }

    clearTipHandler() {
        setTimeout(() => {
            this.props.actions.removeAllTip();
        }, 5);
    }

    getFirstField() {
        return this.props.tableData.sub_cmps.find(item => {
            return item.cmp_data.visible;
        })['cmp_name'];
    }

    getAnalysisData(activeButton) {
        let idArr = [];
        if (Array.isArray(activeButton.data)) {
            activeButton.data.forEach(item => {
                if (item['_id']) {
                    let id =
                        typeof item['_id'] == 'string'
                            ? item['_id']
                            : item['_id']['value']; //行操作按钮是obj
                    idArr.push(id);
                }
            });
        } else if (activeButton.data) {
            const singleId = activeButton.data.id || activeButton.data._id;
            if (singleId) {
                idArr.push(singleId);
            }
        }
        return {
            sourceActionName: activeButton.cmp_data.title || '', //来源动作名称--String
            sourceActionCode: activeButton.cmp_name || '', //来源动作编码--String
            pageCode: activeButton.pageCode || '', //来源页面编码--String
            dataKey: idArr, //GUID--Array
            pages: activeButton.pageName
        };
    }
    // 业务需求：在所有表单保存时追加搜索条件参数
    getSearchParams() {
        let searchData = {};
        const { activeButton = {} } = this.props;
        const { postSearchData } =
            (activeButton && activeButton.cmp_data) || {};
        if (postSearchData && postSearchData.trim() === 'true') {
            searchData = {
                search_data: activeButton && activeButton.searchCriteria
            };
        }
        return searchData;
    }

    getPanel(panelInfo, activeButton, tableData) {
        const searchData = this.getSearchParams();
        let popUp = [];
        if (panelInfo.length) {
            panelInfo.forEach((item, index) => {
                let element = null,
                    panelType =
                        item.popOptions &&
                        item.popOptions.params &&
                        item.popOptions.params.panelType;
                item.popOptions &&
                    (item.popOptions['buttonTitle'] =
                        activeButton &&
                        activeButton.cmp_data &&
                        html.decode(activeButton.cmp_data.title));
                if (panelType == 'form') {
                    element = (
                        <PopUp
                            key={'ButtonCommonPanel' + index}
                            visible={true}
                            animation="bottom-slide-fade"
                            maskAnimation="fade"
                            cls="editform_popup form_popup"
                            lazyRender={true}
                            maskClosable={false}>
                            <EditForm
                                {...item}
                                buttonData={activeButton}
                                isBatch={
                                    activeButton.cmp_data.action ==
                                    'EditBatchButton'
                                }
                                actions={this.actions}
                                dataArr={activeButton.data}
                                confirmData={this.props.confirmData}
                                clearTipHandler={this.clearTipHandler}
                                analysisData={this.getAnalysisData(
                                    activeButton
                                )}
                                searchData={searchData}
                                // isFetchingDataSource={this.props.isFetchingDataSource}
                                tabelListPostParam={
                                    activeButton.tabelListPostParam
                                } // 表单需要的tablelist请求参数
                                searchParam={activeButton.searchCriteria} // 表单需要的tablelist请求参数
                            />
                        </PopUp>
                    );
                } else if (panelType == 'ownerform') {
                    element = (
                        <PopUp
                            key={'ButtonCommonPanel' + index}
                            visible={true}
                            animation="bottom-slide-fade"
                            maskAnimation="fade"
                            cls="editOwnerform_popup form_popup"
                            lazyRender={true}
                            maskClosable={false}>
                            <EditOwnerForm
                                {...item}
                                tableData={
                                    this.props.tableData ||
                                    item.popOptions.tableData
                                }
                                actions={this.actions}
                                dataArr={activeButton.data}
                                analysisData={this.getAnalysisData(
                                    activeButton
                                )}
                                searchData={searchData}
                            />
                        </PopUp>
                    );
                } else if (panelType == 'component') {
                    //弹出一个自定义组件
                    const componentName = item.popOptions.params.componentName;

                    const PopComponent =
                        window._beisenCmp[componentName] ||
                        window['@beisen/beisencloud-mobile'][componentName] ||
                        null;
                    element = (
                        <PopUp
                            visible={true}
                            animation="right-slide-fade"
                            maskAnimation="fade"
                            cls="editform_popup form_popup"
                            maskClosable={!componentName == 'ApprovalForm'}>
                            <PopComponent
                                {...item}
                                actions={this.actions}
                                error={this.props.error}
                                analysisData={this.getAnalysisData(
                                    activeButton
                                )}
                            />
                        </PopUp>
                    );
                } else if (panelType == 'editBatch') {
                    element = (
                        <StandardBatchEdit
                            {...item}
                            selectedTableRows={activeButton.data}
                            batchEdit={this.props.batchEdit}
                            actions={this.actions}
                            clearTipHandler={this.clearTipHandler}
                            analysisData={this.getAnalysisData(activeButton)}
                            firstField={this.getFirstField()}
                            searchData={searchData}
                        />
                    );
                }

                popUp.push(element);
            });
        }

        return popUp;
    }

    // 可以改成弹出任意组件
    getCustomComponent(customButton) {
        if (customButton && customButton.cmp_data) {
            return (
                <PopIndexView
                    buttonData={customButton}
                    actions={this.actions}
                />
            );
        }
    }

    closeOverlay(e) {
        e.preventDefault();
        setTimeout(() => {
            this.props.actions.btnClearFn();
        }, 300);
    }

    selectFields(sortSelect) {
        this.props.actions.btnNextFn({ resultData: sortSelect });
    }

    getConfirm(confirmData) {
        if (!confirmData.show) {
            return null;
        }
        const { translation } = this;
        let popConfirm = (
            <BasicModal
                visible={true}
                animation="zoom"
                maskAnimation="fade"
                title={confirmData.title}
                children={confirmData.children}
                onClose={this.cancleModal}
                footer={[
                    {
                        text: translation.cancel,
                        onTouchTap: this.cancleModal
                    },
                    {
                        text: translation.confirm,
                        onTouchTap: this.submitConfirm
                    }
                ]}
            />
        );
        return popConfirm;
    }

    closeConfirm(sortSelect) {
        this.actions.hideConfirm(sortSelect);
        this.props.actions.btnNextFn();
    }

    cancleModal() {
        let data = this.props.activeButton.data;
        data.confirmActionType = 'cancle';
        // 取消只关闭弹框 不关批量页面
        this.props.actions.hidePopConfirm();
        this.props.actions.btnNextFn(data);
    }

    excuteBusinessLogic(props) {
        if (props.businessLogic && props.businessLogic.view_path) {
            const BusinessLogicComponent =
                window._beisenCmp[props.businessLogic.view_path];
            let resolveFn, rejectFn;
            const promise = new Promise((resolve, reject) => {
                resolveFn = resolve;
                rejectFn = reject;
            });
            promise.then(
                function(resolveData) {
                    this.actions.clearBusinessLogic();
                    this.props.actions.btnNextFn();
                }.bind(this),
                function(rejectData) {
                    this.props.actions.btnClearFn();
                }.bind(this)
            );

            return (
                <BusinessLogicComponent
                    logicResolve={resolveFn}
                    logicReject={rejectFn}
                    {...props.businessLogic.contextParams}
                />
            );
        }
    }

    getBatchPage(tableData, activeButton) {
        if (!tableData) {
            return null;
        } else {
            return (
                <PopUp
                    key="batchPage"
                    visible={true}
                    animation="bottom-slide-fade"
                    maskAnimation="fade"
                    cls="batchPage_popup">
                    <BatchPage
                        {...tableData}
                        title={html.decode(
                            activeButton && activeButton.cmp_data.title
                        )}
                        actions={this.actions}
                        scrollTop={activeButton && activeButton.datatop}
                    />
                </PopUp>
            );
        }
    }

    componentDidUpdate() {
        let { ajaxResp } = this.props;
        const buttonData =
            this.props.activeButton && this.props.activeButton.data;
        const ajaxType = buttonData ? buttonData.ajaxTipType == 'fail' : null;
        // 需重构
        if (ajaxResp && !ajaxType) {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
            this.timeout = setTimeout(() => {
                if (this.props.activeButton && this.props.ajaxResp) {
                    let tipInfo = getTipInfo(ajaxResp);
                    if (tipInfo.type == 'success') {
                        this.props.actions.btnNextFn();
                    } else {
                        //当前不在第一个序列的时候，暂停序列
                        if (
                            this.props.activeButton.lastHandler &&
                            this.props.activeButton.lastHandler > 0
                        ) {
                            return null;
                        }

                        this.props.actions.btnClearFn();
                    }
                }
            }, 500);
        }
    }

    render() {
        const {
            cmp_data,
            sub_cmps,
            activeButton,
            customButton,
            tableData
        } = this.props;
        return (
            <div>
                {activeButton ? (
                    <ActionQueue
                        actions={this.props.actions}
                        {...activeButton}
                        ajaxResp={this.props.resultData}
                        analysisData={this.getAnalysisData(activeButton)}
                    />
                ) : null}
                {this.getBatchPage(tableData, activeButton)}
                {this.getConfirm(cmp_data)}
                {this.excuteBusinessLogic(this.props)}
                {this.getPanel(sub_cmps, activeButton, tableData)}
                {this.getCustomComponent(customButton)}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Button/CommonPlugin.js